<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/15P0q7g/tc-custom/9781399077101.jpg?1729082603560" alt="This image is the cover for the book Battles for Monte Cassino"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Battles for Monte Cassino
      </h1>
      <p class="bookDescription body article font2">
        <p>The Battles for Monte Cassino encompassed one of the few truly international conflicts of the Second World War. A strategic town on the road to Rome, the fighting lasted four months and cost the lives of more than 14,000 men from eight nations. Between January and May 1944, forces from Britain, Canada, France, India, New Zealand, Poland and the United States, fought a resolute German army in a series of battles in which the advantage swung back and forth, from one side to the other. From fire-fights in the mountains to tank attacks in the valley; from river crossings to street fighting, the four battles of Cassino encompass a series of individual operations unique in the history of the Second World War.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jeffrey Plowman, Perry Rowe
      </h2>
      
      <p class="authorDescription body article">Jeffrey Plowman is a research biochemist by profession who has had a keen interest in military history for over thirty-five years. He has made a special study of New Zealand armor and armored units and has published nineteen books as well as many articles and chapters on the subject. Among his most recent publications are War in the Balkans: The Battle for Greece and Crete 1940-1941 and Monte Cassino: Armoured Forces in the Battle for the Gustav Line.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      After the Battle
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?f276d05e